const API_KEY = 'AIzaSyDDAnmzeUkbp8V9Epluii9Af4HppDSKh5g';
const API_ID = 'YOUR_API_ID.apps.googleusercontent.com';
const PLAYLIST_ID = 'PLcmzLP6M_9KrIW9fcCdlkoPfGZ3soAsXY';

const playlistItems = [];
const playlist = document.getElementsByClassName("playlist")[0];

// From Google API Docs
function initAPIClient() {
  gapi.load("client:auth2", function() {
    gapi.auth2.init({client_id: API_ID});
  });  
};

// From Google API Docs
function authenticate() {
  return gapi.auth2.getAuthInstance()
    .signIn({scope: "https://www.googleapis.com/auth/youtube.readonly"})
    .then(function() { console.log("Sign-in successful"); },
          function(err) { console.error("Error signing in", err); });
}

// From Google API Docs
function loadClient() {
  gapi.client.setApiKey(API_KEY);
  return gapi.client.load("https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest")
    .then(function() { console.log("GAPI client loaded for API"); },
          function(err) { console.error("Error loading GAPI client for API", err); });
}

// Proxy, for example, when you need to request an access only, not performing anything else
function auth() {
  return new Promise(function(resolve) {
    resolve(authenticate().then(loadClient));
  }
)}

function getItems() {
  // Refactor this, if you're doing the `auth` method separately
  auth().then(getPlaylistItems);  
}

function getPlaylistItems(pageToken) {
    return gapi.client.youtube.playlistItems.list({
      "part": "snippet,contentDetails",
      "maxResults": 50, // This is the maximum available value, according to the google docs
      "playlistId": PLAYLIST_ID,
      pageToken
    })
      .then(function(response) {
      const { items, nextPageToken } = response.result;
      
      // The items[] is an array of a playlist items.
      // nextPageToken - if empty - there are no items left to fetch
      
      playlistItems.push(...items);
      
      // It's up to you, how to handle the item from playlist. 
      // Add `onclick` events to navigate to another video, or use another thumbnail image quality 
      items.forEach(function(item) {
          const thumbnailItem = createPlaylistItem(item);
          playlist.appendChild(thumbnailItem);
        });
      

      // Recursively get another portion of items, if there any left
      if (nextPageToken) {
        getPlaylistItems(nextPageToken);        
      }
    },
  function(err) { console.error("Execute error", err); });
}

function createPlaylistItem(i) {
  const item = document.createElement('div');
  item.classList.add('playlist-item');
  item.style.background = `url(${i.snippet.thumbnails.default.url}) no-repeat center`;
  item.style.backgroundSize = 'contain';
  return item;
};

// Before doing any action with the API ->
initAPIClient();
